import { createSlice } from "@reduxjs/toolkit";


export const alarmsFilterSlice = createSlice({
  name: "alarmsFilter",
  initialState: {
          date: {
            startTime: new Date().setDate(new Date().getDate() - 7),
            endTime: new Date().setDate(new Date().getDate())
          },
          status: ["ACTIVE","ACKNOWLEDGED"],
          // solution names; [] means all of the user's solutions
          solutions: [],
          priority: [],
          emails: false,
          actuations: false,
          // one search box, matched by the server on the asset name and/or the rule
          search: {
            text: "",
            by: ["asset", "rule"]
          }
        },
  reducers: {
    setAlarmsFilter: (state, action) => {
      return action.payload
    },
    // each filter control writes only its own key
    updateAlarmsFilter: (state, action) => {
      return { ...state, ...action.payload }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAlarmsFilter, updateAlarmsFilter } = alarmsFilterSlice.actions;

export default alarmsFilterSlice.reducer;
